import { abIfExpField } from '@df/module-ab/cms2/ab-cms2';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { menuField as localMenuField } from './page/header/page-header.config';
export interface IMenuTab<T extends {}> {
    text: string;
    id: string;
    menu: T[];
    abIfExp?: string;
}
export function addMenuTabs(
    config: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>,
    menuField = localMenuField
): void {
    const indexOfMenuField = config.fields.indexOf(menuField);
    const meganavTabs: NICmsContentField.IRepeaterField = {
        key: 'menuTabs',
        type: NICmsContentField.EFieldType.repeater,
        title: 'Menu Tabs',
        itemName: 'Menu Tab',
        itemNameField: 'tab',
        complex: true,
        maxSize: 1,
        fields: [
            {
                key: 'text',
                type: NICmsContentField.EFieldType.text,
                title: 'Tab title',
                required: true
            },
            {
                key: 'id',
                type: NICmsContentField.EFieldType.text,
                title: 'Tab Id',
                required: true
            },
            menuField,
            { ...abIfExpField, group: undefined, key: 'abIfExp' }
        ]
    };
    if (indexOfMenuField > -1) {
        config.fields.splice(indexOfMenuField, 1, meganavTabs);
    } else {
        config.fields.push(meganavTabs);
    }
}
